// Sidebar Menu - Maison Madise
(function () {
  // Masquer h1 immédiatement si on est sur une page de collection gérée
(function() {
  if (/^\/collections\//.test(window.location.pathname)) {
    const s = document.createElement('style');
    s.id = 'mm-h1-hide';
    s.textContent = 'h1 { visibility: hidden !important; }';
    document.head.appendChild(s);
  }
})();
  const subMenus = {
    "décoration": [
      { label: "Accessoires de bureau", url: "/collections/accessoires-de-bureau", collection: "accessoires-de-bureau", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Accessoires_bureau.jpg?v=1781645716" },
      { label: "Bougies, bougeoirs et parfums", url: "/collections/bougies-et-bougeoirs", collection: "bougies-et-bougeoirs", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Bougies.jpg?v=1781642900" },
      { label: "Coussins et plaids", url: "/collections/coussins-et-plaids", collection: "coussins-et-plaids", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Coussins.jpg?v=1781645531" },
      { label: "Décorations murales", url: "/collections/affiches", collection: "affiches", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/files/Augustin.jpg?v=1780924039" },
      { label: "Paniers et boîtes", url: "/collections/boite-a-mouchoirs", collection: "boite-a-mouchoirs", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/boites_a_mouchoirs.jpg?v=1781512040" },
      { label: "Sculptures", url: "/collections/sculptures", collection: "sculptures", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/files/sculptures.jpg?v=1781689144" },
      { label: "Tapis", url: "/collections/tapis", collection: "tapis", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Tapis.jpg?v=1781643040" },
      { label: "Vases et cache-pots", url: "/collections/vases-et-cache-pots", collection: "vases-et-cache-pots", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Vases_et_cache_pots.jpg?v=1781646369" },
    ],
    "art de la table": [
      { label: "Accessoires", url: "/collections/accessoires", collection: "accessoires", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/accessoires.jpg?v=1781015287" },
      { label: "Couverts", url: "/collections/couverts", collection: "couverts", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/couverts.jpg?v=1781013997" },
      { label: "Nappes", url: "/collections/nappes", collection: "nappes", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/nappe.jpg?v=1781014952" },
      { label: "Pichets et carafes", url: "/collections/pichets-et-carafes", collection: "pichets-et-carafes", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Vases_et_cache_pots_52f1ab07-ac14-4705-8aba-b157266b8e88.jpg?v=1781645977" },
      { label: "Serviettes et torchons", url: "/collections/serviettes", collection: "serviettes", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Serviette.jpg?v=1781015090" },
      { label: "Sets de table", url: "/collections/sets-de-table", collection: "sets-de-table", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Set_de_table.jpg?v=1781014818" },
      { label: "Vaisselle", url: "/collections/vaisselle", collection: "vaisselle", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/vaiselle.jpg?v=1781014324" },
      { label: "Verres", url: "/collections/verres", collection: "verres", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/verres.jpg?v=1781015185" },
    ],
    "luminaires": [
      { label: "Appliques", url: "/collections/appliques", collection: "appliques", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Appliques_murales.jpg?v=1781642149" },
      { label: "Lampes à poser", url: "/collections/lampes-a-poser", collection: "lampes-a-poser", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Lampe_a_poser.jpg?v=1781641958" },
      { label: "Suspensions", url: "/collections/suspensions", collection: "suspensions", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Suspension.jpg?v=1781641713" },
    ],
    "maroquinerie": [
      { label: "Porte-cartes", url: "/collections/porte-cartes", collection: "porte-cartes", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Porte_carte.jpg?v=1781641502" },
      { label: "Porte-passeports", url: "/collections/porte-passeports", collection: "porte-passeports", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Porte_passeport.jpg?v=1781641338" },
    ],
    "mobilier": [
      { label: "Mobilier", url: "/collections/mobilier", collection: "mobilier", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/files/Mobilier.jpg?v=1781677579" },
    ],
    "papeterie": [
      { label: "Cahiers", url: "/collections/cahiers", collection: "cahiers", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Cahiers.jpg?v=1781678171" },
      { label: "Carnets", url: "/collections/carnets", collection: "carnets", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/collections/Carnets.jpg?v=1781678511" },
      { label: "Cartes", url: "/collections/cartes", collection: "cartes", image: "https://cdn.shopify.com/s/files/1/1042/7121/6904/files/cartes.jpg?v=1781678677" },
    ],
  };
  // Partager les sous-catégories avec la page Catalogue.
  window.maisonMadiseSubMenus = subMenus;
  document.dispatchEvent(new Event('mm:submenus-ready'));

  // Map handle → clé subMenus
  const collectionHandleMap = {
    "art-de-la-table": "art de la table",
    "decoration": "décoration",
    "luminaires": "luminaires",
    "maroquinerie": "maroquinerie",
    "mobilier": "mobilier",
    "papeterie": "papeterie"
  };

  // Map handle → titre affiché
  const collectionTitles = {
    "art-de-la-table": "Art de la table",
    "decoration": "Décoration",
    "luminaires": "Luminaires",
    "maroquinerie": "Maroquinerie",
    "mobilier": "Mobilier",
    "papeterie": "Papeterie"
  };

  // Map inverse : sous-collection → handle parent
  const subcollectionParentMap = {};
  Object.keys(collectionHandleMap).forEach(parentHandle => {
    const parentKey = collectionHandleMap[parentHandle];
    (subMenus[parentKey] || []).forEach(item => {
      subcollectionParentMap[item.collection] = parentHandle;
    });
  });

  // DOM méga menu
  const overlay = document.createElement("div");
  overlay.id = "mm-sidebar-overlay";

  const sidebar = document.createElement("div");
  sidebar.id = "mm-sidebar";
  sidebar.innerHTML = `
    <div id="mm-sidebar-nav">
      <p id="mm-sidebar-title"></p>
      <ul class="mm-sidebar-links"></ul>
    </div>
    <div id="mm-sidebar-preview"></div>
    <button id="mm-sidebar-close" aria-label="Fermer">✕</button>
  `;

  document.body.appendChild(overlay);
  document.body.appendChild(sidebar);

  const sidebarTitle = sidebar.querySelector("#mm-sidebar-title");
  const sidebarLinks = sidebar.querySelector(".mm-sidebar-links");
  const sidebarPreview = sidebar.querySelector("#mm-sidebar-preview");
  const closeBtn = sidebar.querySelector("#mm-sidebar-close");

  const collectionCache = {};

  async function fetchCollection(handle) {
    if (collectionCache[handle]) return collectionCache[handle];
    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=24`);
      const data = await res.json();
      collectionCache[handle] = data.products || [];
      return collectionCache[handle];
    } catch (e) {
      return [];
    }
  }

  async function showCollectionImage(item) {
    if (!item.collection) {
      sidebarPreview.innerHTML = `<p class="mm-preview-empty">Aucun aperçu disponible.</p>`;
      return;
    }
    sidebarPreview.innerHTML = `<p class="mm-preview-empty">Chargement…</p>`;
    const products = await fetchCollection(item.collection);
    if (!products.length) {
      sidebarPreview.innerHTML = `<p class="mm-preview-empty">Aucun produit trouvé.</p>`;
      return;
    }
    sidebarPreview.innerHTML = `
      <a class="mm-collection-link" href="${item.url}">Voir toute la collection →</a>
      <div class="mm-preview-grid">
        ${products.slice(0, 4).map((p) => {
          const imgs = p.images.slice(0, 5);
          const hasMultiple = imgs.length > 1;
          const imgHTML = imgs.map((img, i) =>
            `<img src="${img.src}" alt="${p.title}" loading="lazy" style="display:${i === 0 ? 'block' : 'none'}" data-index="${i}">`
          ).join('');
          return `
            <a class="mm-preview-item" href="/products/${p.handle}">
              <div class="mm-preview-img-wrap">
                ${imgHTML}
                ${hasMultiple ? `
                  <button class="mm-img-prev" data-total="${imgs.length}">&#8249;</button>
                  <button class="mm-img-next" data-total="${imgs.length}">&#8250;</button>
                ` : ''}
              </div>
              <span>${p.title}</span>
            </a>`;
        }).join("")}
      </div>
    `;
  }

  function setActiveLink(activeEl) {
    sidebarLinks.querySelectorAll("a").forEach((a) => a.classList.remove("is-active"));
    activeEl.classList.add("is-active");
  }

  function openSidebar(label, links) {
    sidebarTitle.textContent = label;
    sidebarLinks.innerHTML = links
      .map((l, i) => `<li><a href="${l.url}" data-index="${i}">${l.label}</a></li>`)
      .join("");

    const firstLink = sidebarLinks.querySelector("a");
    if (firstLink) {
      firstLink.classList.add("is-active");
      showCollectionImage(links[0]);
    }

    sidebarLinks.querySelectorAll("a").forEach((a) => {
      a.addEventListener("mouseenter", () => {
        setActiveLink(a);
        const idx = parseInt(a.dataset.index);
        showCollectionImage(links[idx]);
      });
    });

  sidebar.classList.add("is-open");
    overlay.classList.add("is-open");

    // Mesurer l'en-tête dans son état visible,
    // une fois les styles d'ouverture appliqués.
    updateSidebarBounds();

    // Recalculer au prochain rendu si sa disposition a changé.
    scheduleSidebarBoundsUpdate();

    // Toujours ouvrir les deux colonnes depuis le haut.
    sidebar.querySelector("#mm-sidebar-nav").scrollTop = 0;
    sidebarPreview.scrollTop = 0;
  }

  function updateSidebarBounds() {
    const header = document.querySelector("#header-component");


    const viewportHeight = window.innerHeight;
    const measuredBottom = header
      ? header.getBoundingClientRect().bottom
      : 0;

    const headerBottom = Math.max(
      0,
      Math.min(measuredBottom, viewportHeight)
    );

    const availableHeight = Math.max(
      0,
      viewportHeight - headerBottom
    );

    sidebar.style.top = headerBottom + "px";
    sidebar.style.maxHeight = availableHeight + "px";
    overlay.style.top = headerBottom + "px";
  }

  let sidebarBoundsFrame = null;

  function scheduleSidebarBoundsUpdate() {
    if (!sidebar.classList.contains("is-open")) return;
    if (sidebarBoundsFrame !== null) return;

    sidebarBoundsFrame = requestAnimationFrame(() => {
      sidebarBoundsFrame = null;
      updateSidebarBounds();
    });
  }

  window.addEventListener(
    "resize",
    scheduleSidebarBoundsUpdate,
    { passive: true }
  );

  window.addEventListener(
    "scroll",
    scheduleSidebarBoundsUpdate,
    { passive: true }
  );

  function closeSidebar() {
    sidebar.classList.remove("is-open");
    overlay.classList.remove("is-open");
  }

  closeBtn.addEventListener("click", closeSidebar);
  overlay.addEventListener("click", closeSidebar);

  // Fermer le méga menu lorsque la souris sort par le bas.
  sidebar.addEventListener("mouseleave", function (event) {
    if (!window.matchMedia("(hover: hover)").matches) return;

    const bottom = sidebar.getBoundingClientRect().bottom;

    if (event.clientY >= bottom - 1) {
      closeSidebar();
    }
  });
  
  function attachMenuEvents() {
    const navLinks = document.querySelectorAll(
      "header nav a, .header__nav a, .nav__link, .site-nav a"
    );
    navLinks.forEach((link) => {
      const key = link.textContent.trim().toLowerCase();

      // Desktop : hover
      link.addEventListener("mouseenter", () => {
        subMenus[key] ? openSidebar(link.textContent.trim(), subMenus[key]) : closeSidebar();
      });

      // Mobile : premier tap ouvre le menu, deuxième tap navigue
      link.addEventListener("click", (e) => {
        if (!subMenus[key]) { closeSidebar(); return; }
        const isTouchDevice = window.matchMedia("(hover: none)").matches;
        if (isTouchDevice && link.dataset.menuOpen !== 'true') {
          e.preventDefault();
          openSidebar(link.textContent.trim(), subMenus[key]);
          link.dataset.menuOpen = 'true';
          // Réinitialise après 3 secondes si pas de deuxième tap
          setTimeout(() => { link.dataset.menuOpen = 'false'; }, 3000);
        } else {
          link.dataset.menuOpen = 'false';
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachMenuEvents);
  } else {
    attachMenuEvents();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mm-img-prev, .mm-img-next');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const wrap = btn.closest('.mm-preview-img-wrap');
    const imgs = wrap.querySelectorAll('img');
    const total = parseInt(btn.dataset.total);
    let current = [...imgs].findIndex(img => img.style.display === 'block');
    imgs[current].style.display = 'none';
    if (btn.classList.contains('mm-img-next')) {
      current = (current + 1) % total;
    } else {
      current = (current - 1 + total) % total;
    }
    imgs[current].style.display = 'block';
  });

function injectSubcategoryBar() {
  const removeHide = () => {
    const s = document.getElementById('mm-h1-hide');
    if (s) s.remove();
  };

  // Fallback : révèle le h1 après 300ms même si le JS échoue
  setTimeout(() => {
    const h1 = document.querySelector('h1');
    if (h1) h1.style.visibility = 'visible';
  }, 300);

  const path = window.location.pathname;
  const match = path.match(/^\/collections\/([^/?]+)/);
  if (!match) { removeHide(); return; }

  let handle = match[1];
  const currentCollection = handle;

  if (subcollectionParentMap[handle]) {
    handle = subcollectionParentMap[handle];
  }

  const parentKey = collectionHandleMap[handle];
  if (!parentKey || !subMenus[parentKey]) {
    removeHide();
    return;
  }

  const links = subMenus[parentKey];
  if (!links.length) { removeHide(); return; }

  requestAnimationFrame(() => {
    const h1 = document.querySelector('h1');

    if (h1 && collectionTitles[handle]) {
      h1.innerHTML = collectionTitles[handle];
    }
    if (h1) h1.style.visibility = 'visible';

    const bar = document.createElement('div');
    bar.id = 'mm-subcategory-bar';

    // Boutons actuels : conservés pour tablette et ordinateur.
    bar.innerHTML = links.map(l =>
      `<a href="${l.url}" class="mm-subcategory-btn${l.collection === currentCollection ? ' is-active' : ''}">${l.label}</a>`
    ).join('');

    // Liste déroulante : visible uniquement sur smartphone.
    const select = document.createElement('select');
    select.id = 'mm-subcategory-select';
    select.className = 'mm-subcategory-select';
    select.setAttribute('aria-label', 'Choisir une catégorie');

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Choisir une catégorie';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    links.forEach(l => {
      const option = document.createElement('option');
      option.value = l.url;
      option.textContent = l.label;

      if (l.collection === currentCollection) {
        placeholder.selected = false;
        option.selected = true;
      }

      select.appendChild(option);
    });

    select.addEventListener('change', () => {
      if (select.value) {
        window.location.assign(select.value);
      }
    });

    bar.appendChild(select);

    if (h1 && h1.parentNode) {
      h1.parentNode.insertBefore(bar, h1.nextSibling);
    }

    removeHide();
  });
}

// Désactiver le bfcache pour éviter le flash de la page précédente
window.addEventListener('pageshow', function(e) {
  if (e.persisted) {
    window.location.reload();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectSubcategoryBar);
} else {
  injectSubcategoryBar();
}

})();